import { forwardRef } from 'react'

import { styled } from 'styled-components'

import buttonStyles from '../Button/buttonStyles'

const Trigger = styled.button`
  ${buttonStyles}
`

const TriggerLabel = styled.span`
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Chevron = styled.span`
  flex-shrink: 0;
  padding-left: 8px;
  color: ${(p) => (p.disabled ? p.theme.disabledText : p.theme.mutedText)};
`

const MenuTrigger = forwardRef((props, ref) => {
  const { isOpen, onOpen, onClose, label, disabled } = props

  const handleKeyDown = (event) => {
    if (props.onKeyDown) props.onKeyDown(event)
    if (event.key === 'ArrowDown') {
      event.preventDefault()
      onOpen()
    }
  }

  return (
    <Trigger
      ref={ref}
      onClick={isOpen ? onClose : onOpen}
      onKeyDown={handleKeyDown}
      disabled={disabled}
    >
      <TriggerLabel>{label}</TriggerLabel>
      <Chevron disabled={disabled}>▼</Chevron>
    </Trigger>
  )
})

MenuTrigger.displayName = 'MenuTrigger'

export default MenuTrigger
